/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EstimatedCostDtoPage } from '../models/estimated-cost-dto-page';
import { listEstimatedCosts } from '../fn/estimated-cost/list-estimated-costs';
import { ListEstimatedCosts$Params } from '../fn/estimated-cost/list-estimated-costs';

@Injectable({ providedIn: 'root' })
export class EstimatedCostApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEstimatedCosts()` */
  static readonly ListEstimatedCostsPath = '/v0/estimatedCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEstimatedCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedCosts$Response(params?: ListEstimatedCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedCostDtoPage>> {
    return listEstimatedCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEstimatedCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedCosts(params?: ListEstimatedCosts$Params, context?: HttpContext): Observable<EstimatedCostDtoPage> {
    return this.listEstimatedCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedCostDtoPage>): EstimatedCostDtoPage => r.body)
    );
  }

}
